import styled from "styled-components";

export const Icon = styled.span<{ size: any }>`
  &[class^="icon-"],
  &[class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icomoon" !important;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    font-size: ${props => props.size};

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  &.icon-bandcamp:before {
    content: "\\e900";
  }
  &.icon-facebook:before {
    content: "\\ea90";
  }
  &.icon-instagram:before {
    content: "\\ea92";
  }
  &.icon-twitter:before {
    content: "\\ea96";
  }
  &.icon-soundcloud:before {
    content: "\\eac3";
  }
  &.icon-discogs:before {
    content: "\\e901";
  }
  &.icon-envelop:before {
    content: "\\e945";
  }
`;
